module.exports = __webpack_public_path__ + "img/ic_email.510262dd.svg";